import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigation } from '../../hooks/useNavigation';
import { NAVIGATION } from '../../utils/constants';

export function NavLinks() {
  const { isActive } = useNavigation();

  return (
    <div className="hidden md:flex space-x-8">
      {NAVIGATION.map(({ path, label }) => (
        <Link
          key={path}
          to={path}
          className={`${
            isActive(path) ? 'text-[#C4A484]' : 'text-gray-600'
          } hover:text-[#C4A484] transition-colors`}
        >
          {label}
        </Link>
      ))}
    </div>
  );
}